import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "@/utils/cn";

export type ReplacementGradientFrameTone =
  | "solidWhite"
  | "hoverWash"
  | "gradientFill";

export type ReplacementGradientFrameProps = {
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  tone?: ReplacementGradientFrameTone;
  variant?: "default" | "scenario";
} & Omit<ComponentPropsWithoutRef<"div">, "className" | "children">;

function innerToneClass(tone: ReplacementGradientFrameTone): string {
  if (tone === "gradientFill") return "bg-transparent";
  if (tone === "hoverWash") {
    return "bg-white transition-colors duration-200 group-hover:bg-transparent";
  }
  return "bg-white";
}

export default function ReplacementGradientFrame({
  children,
  className,
  innerClassName,
  tone = "solidWhite",
  variant = "default",
  ...props
}: ReplacementGradientFrameProps) {
  const isScenario = variant === "scenario";

  return (
    <div
      {...props}
      className={cn(
        "group box-border rounded-[10px] bg-gradient-to-r from-[#07ACE3] via-[#0D5DF7] to-[#FE0E82] p-[2px] shadow-sm",
        isScenario && "h-full min-w-0 w-full",
        className
      )}
    >
      <div
        className={cn(
          "box-border h-full w-full rounded-[8px]",
          innerToneClass(tone),
          tone === "gradientFill" && "text-background",
          isScenario && "flex min-h-0 flex-col overflow-hidden",
          innerClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
